module.exports = __webpack_public_path__ + "static/media/team_work_cn01.760f1380.png";